import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { closePopup } from 'features/popup/store/actions'
import { onAddUsersFromPopup } from 'features/teamlist/store/actions'
import { ReusableButton, BlurLayer } from 'gipsy-ui'
import { InviteUserInputId, default as InviteUserInput } from 'features/teamlist/components/inviteUserInput'
import { getSrc } from 'utils/image'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      closePopup,
      onAddUsersFromPopup
    },
    dispatch
  )
})

const mapStateToProps = state => ({
  active: state.popup.active,
  title: state.popup.title,
  message: state.popup.message,
  button: state.popup.button,
  buttonClass: state.popup.buttonClass,
  action: state.popup.action,
  onClose: state.popup.onClose,
  componentId: state.popup.componentId,
  component: state.popup.component,
  headerComponent: state.popup.headerComponent,
  logo: state.popup.logo
})

class Popup extends PureComponent {
  doAction = () => {
    if (this.props.action && typeof this.props.action === 'function') {
      this.props.action()
    } else if (this.props.action && typeof this.props.action === 'string' && this[this.props.action]) {
      this[this.props.action]()
    }
  }

  selectComponent = componentId => {
    switch (componentId) {
      case InviteUserInputId:
        return <InviteUserInput onAddUsers={this.props.actions.onAddUsersFromPopup} />
      default:
        return undefined
    }
  }

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
    this.props.actions.closePopup()
  }

  render() {
    const { active, title, message, button, buttonClass, componentId, component, headerComponent, logo } = this.props

    let logoSrc
    if (logo === 'happy') {
      logoSrc = getSrc('/images/gipsybot-happy.svg')
    } else if (logo === 'lookdown') {
      logoSrc = getSrc('/images/gipsybot-lookdown.svg')
    } else {
      logoSrc = getSrc('/images/gipsybot-white.svg')
    }
    return (
      <BlurLayer name="popup" active={active} onClose={this.onClose}>
        <Row>{headerComponent}</Row>
        <Row>
          <div className="popup-logo">
            <img src={logoSrc} alt="logo" />
          </div>
          <div className="popup-title">{title}</div>
          <div className="popup-message">{message}</div>

          {this.props.action && (
            <div className="popup-action">
              <ReusableButton width={200} height={56} onClick={this.doAction} className={buttonClass}>
                {button}
              </ReusableButton>
            </div>
          )}
          {componentId && <div className="popup-component">{this.selectComponent(componentId)}</div>}
          {component}
        </Row>
      </BlurLayer>
    )
  }
}

const Row = styled.div``

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(Popup)



// WEBPACK FOOTER //
// ./src/features/popup/index.js